var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"mb-6"},[_c('h6',{staticClass:"text-white mb-2"},[_vm._v("Saldo Saya")]),_c('h3',{staticClass:"text-white"},[_c('strong',[_vm._v("Rp "+_vm._s(_vm.formatRupiah( _vm.data.balance ))+",")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }